module.exports = __webpack_public_path__ + "img/服务网络覆盖图.dccbe0e6.png";